import { createSelector } from '@reduxjs/toolkit'
import head from 'lodash/head'
import { TimeSchedule } from '@/models/service'
import { convertLocalTimeToUTCTime } from '@/utils/dateUtils'
import { timeScheduleSlice } from '..'

export const visibleTimeSchedulesSelector = createSelector(
  [
    timeScheduleSlice.selectors.selectedDays,
    timeScheduleSlice.selectors.service,
  ],
  (selectedDays, service): TimeSchedule[] => {
    const firstSelectedDay = head(selectedDays)
    if (!firstSelectedDay || !service) {
      return []
    }

    const toUTC = convertLocalTimeToUTCTime(firstSelectedDay)
    const timeSchedules = service.dailyTimeSchedules[toUTC]

    const groupedTimeSchedules = timeSchedules.reduce<
      Record<string, TimeSchedule>
    >((acc, ts) => {
      selectedDays.forEach((day, idx) => {
        const dayUTC = convertLocalTimeToUTCTime(day)

        const found = service.dailyTimeSchedules[dayUTC].find(
          (dts) => dts.startTime === ts.startTime && dts.endTime === ts.endTime
        )
        const key = ts.startTime + '' + ts.endTime
        const prev = acc[key]
        if (idx === 0) {
          acc[key] = ts
        } else if (prev && found) {
          acc[key] = {
            ...ts,
            price: found.price + prev.price,
          }
        } else if (prev && !found) {
          delete acc[key]
        }
      })
      return acc
    }, {})

    return Object.values(groupedTimeSchedules)
  }
)
